import { render, staticRenderFns } from "./ProgrammingLanguageDetails.vue?vue&type=template&id=d3b8aa68&scoped=true"
import script from "./ProgrammingLanguageDetails.vue?vue&type=script&lang=js"
export * from "./ProgrammingLanguageDetails.vue?vue&type=script&lang=js"
import style0 from "./ProgrammingLanguageDetails.vue?vue&type=style&index=0&id=d3b8aa68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b8aa68",
  null
  
)

export default component.exports